/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Operations_Title_2Inputs */

const en_wb_operations_title_2 = /** @type {(inputs: Wb_Operations_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The missing detail is caught.`)
};

const lv_wb_operations_title_2 = /** @type {(inputs: Wb_Operations_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trūkstošā detaļa ir pamanīta.`)
};

/**
* | output |
* | --- |
* | "The missing detail is caught." |
*
* @param {Wb_Operations_Title_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_operations_title_2 = /** @type {((inputs?: Wb_Operations_Title_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Operations_Title_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_operations_title_2(inputs)
	return en_wb_operations_title_2(inputs)
});